import Joyride from "react-joyride";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { PinRegular } from "@fluentui/react-icons";

const unicliStyle = {
  fontFamily: "Segoe UI",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "10px",
};

const step2Content = ({ addinType, isReplyWindow }) => {
  return (
    <div style={{ textAlign: "left" }}>
      {!isReplyWindow || addinType === "WORD"
        ? "Select between compose and chat modes:"
        : "Select between reply and chat modes:"}
      <br />
      {addinType === "WORD"
        ? "Use compose mode to generate a new document section or revise document selection."
        : !isReplyWindow
        ? "Use compose mode to generate a new email draft or revise email selection."
        : "Use reply mode to generate a draft reply to the current email."}
      <br />
      Use chat mode to ask the assistant questions.
    </div>
  );
};

const step3Content = ({ addinType, isReplyWindow }) => {
  return (
    <div style={{ textAlign: "left" }}>
      {!isReplyWindow || addinType === "WORD"
        ? "In compose mode, you can provide optional instructions to the assistant."
        : "In reply mode, you can provide optional instructions to the assistant."}
      <br />
      {!isReplyWindow || addinType === "WORD"
        ? "The assistant will use these instructions to generate a draft."
        : "The assistant will use these instructions to generate a reply."}
    </div>
  );
};

const step4Content = ({ addinType, isReplyWindow }) => {
  return (
    <div style={{ textAlign: "left" }}>
      {addinType === "WORD"
        ? "Use submit button to generate document contents or revise text selection."
        : isReplyWindow
        ? "Use submit button to generate the reply draft."
        : "Use submit button to generate a new draft or revise the email selection."}
    </div>
  );
};

const step8Content = ({ addinType, isReplyWindow }) => {
  return (
    <div style={{ textAlign: "left" }}>
      {!isReplyWindow || addinType === "WORD"
        ? "Use the compose button to switch back to compose mode."
        : "Use the reply button to switch back to reply mode."}
    </div>
  );
};
const step10Content = ({ addinType }) => {
  return (
    <div style={{ textAlign: "left" }}>
      <PinRegular style={{ marginRight: "5px" }} />
      {addinType === "WORD"
        ? "Pin the pane to open Unicli automatically when you open a document."
        : "Pin the pane to open Unicli automatically when you open an email."}
    </div>
  );
};
const JoyrideTour = ({ addinType, setInputString, isReplyWindow, run, stepIndex }) => {
  const steps = [
    {
      style: unicliStyle,
      target: "#chatbot",
      content: <div style={{ textAlign: "left" }}>Let&apos;s get started with a quick tour of Unicli!</div>,
      offset: 50,
    },
    {
      style: unicliStyle,
      target: "#contextDropdown",
      content: (
        <div style={{ textAlign: "left" }}>
          Use the dropdown menu to select a property. Unicli will use property-specific documents when
          processing your requests. 
        </div>
      ),
    },
    {
      style: unicliStyle,
      target: "#respondChatTabs",
      content: step2Content({ addinType, isReplyWindow }),
    },
    {
      style: unicliStyle,
      target: "#userPromptArea",
      content: step3Content({ addinType, isReplyWindow }),
    },
    {
      style: unicliStyle,
      target: "#toneSelector",
      content: <div style={{ textAlign: "left" }}>Slect the desired tone and writing style. Eplanatory and Concise writing styles are configurable from the Unicli Portal.</div>,
    },
    {
      style: unicliStyle,
      target: "#submitButton",
      content: step4Content({ addinType, isReplyWindow }),
    },
    {
      style: unicliStyle,
      target: "#chattab",
      content: <div style={{ textAlign: "left" }}>Use the chat button to switch to chat mode.</div>,
    },
    {
      style: unicliStyle,
      target: "#userPromptArea",
      content: (
        <div style={{ textAlign: "left" }}>
          Use chat mode to ask the assistant questions about your current email or any general inquiries.
        </div>
      ),
    },
    {
      style: unicliStyle,
      target: "#submitButton",
      content: <div style={{ textAlign: "left" }}>Use submit button to send the question to the assistant.</div>,
    },
    {
      style: unicliStyle,
      target: isReplyWindow ? "#replyalltab" : "#composetab",
      content: step8Content({ addinType, isReplyWindow }),
    },
    {
      style: unicliStyle,
      target: "#newTopicButton",
      content: <div style={{ textAlign: "left" }}>Use the new topic button to clear the conversation history.</div>,
    },
    {
      style: unicliStyle,
      placement: "right",
      target: "#pinTooltipPlaceholder",
      content: step10Content({ addinType }),
    },
    {
      style: unicliStyle,
      target: "#handleHelpButton",
      content: (
        <div style={{ textAlign: "left" }}>
          Come back here anytime to restart the tour or open Unicli Knowledge base.
        </div>
      ),
    },
  ];

  const handleJoyrideCallback = (data) => {
    const { action, index, type } = data;
    if (action === "skip" || action === "close") {
      localStorage.setItem("storedTourSeen", true);
    }
    if (type === "step:after" && index === 2) {
      setInputString(
        isReplyWindow ? "Include parking rules in the reply." : "Invite council members to the next meeting."
      );
    }
    if (type === "step:after" && index === 5) {
      setInputString("What is the fee for strata lot 45?");
      const button = document.getElementById("chattab");
      if (button) {
        button.click();
      }
    }
    if (type === "step:after" && index === 8) {
      const button = document.getElementById(isReplyWindow ? "replyalltab" : "composetab");
      if (button) {
        button.click();
      }
      setInputString("");
    }
    if (type === "step:after" && index === 11) {
      localStorage.setItem("storedTourSeen", true);
    }
  };

  const filteredSteps = steps.filter((step, index) => {
    // Example: Remove step at index 5 if addinType is "specificType"
    if (addinType === "WORD" && index === 11) {
      return false; // Exclude this step
    }
    return true; // Include all other steps
  });

  return (
    <Joyride
      steps={filteredSteps}
      continuous={true}
      showProgress={false}
      showSkipButton={true}
      run={run}
      stepIndex={stepIndex}
      spotlightClicks={true}
      callback={handleJoyrideCallback}
      styles={{
        options: {
          primaryColor: "#357C7C",
          zIndex: 10000,
        },
      }}
      locale={{
        last: "Get Started!", // Custom label for the last button
        next: "Next",
        back: "Back",
        skip: "Skip",
        close: "Close",
      }}
    />
  );
};
JoyrideTour.propTypes = {
  setInputString: PropTypes.func.isRequired,
  isReplyWindow: PropTypes.bool.isRequired,
  run: PropTypes.bool.isRequired,
  stepIndex: PropTypes.number,
  addinType: PropTypes.string.isRequired,
};

export default JoyrideTour;
